
// import { create } from 'zustand';
// import { persist, createJSONStorage } from 'zustand/middleware';
// import odooClient from '../services/odooClient';
// import { check2FAStatus } from '../services/odoo2fa';
// import { useCurrencyStore } from './currencyStore';

// export interface User {
//   id: string;
//   email: string;
//   firstName: string;
//   lastName: string;
//   role: 'admin' | 'user';
//   gallery: 'myself' | 'worldwide';
//   permissions?: string[];
// }

// interface AuthState {
//   token: string | null;
//   user: User | null;
//   isAuthenticated: boolean;
//   login: (login: string, password: string) => Promise<void>;
//   logout: () => void;
//   updateUser: (user: Partial<User>) => void;
//   setAuthenticated: (value: boolean) => void;       // ✅ added
//   refreshSession: () => Promise<void>;              // ✅ added
// }

// export const useAuthStore = create<AuthState>()(
//   persist(
//     (set: any, get) => ({
//       token: null,
//       user: null,
//       isAuthenticated: false,

//       // 🚀 FAST LOGIN WITH DIRECT ODOO
//       login: async (loginStr: string, password: string) => {
//         try {
//           const { user: odooUser, sessionId } = await odooClient.authenticate(loginStr, password);
//           const status = await check2FAStatus(sessionId);

//           console.log("2FA Status:", status);


//           const statusData = status.result || status;

//           // 🔸 If 2FA is enabled but not verified yet
//           if (statusData.enabled && !statusData.verified) {
//             set({
//               user: odooUser,
//               token: null,
//               isAuthenticated: false,
//             });
//             localStorage.setItem('pending_2fa_session', sessionId);
//             const err: any = new Error("2FA_REQUIRED");
//             err.code = "2FA_REQUIRED";
//             throw err;
//           }

//           const permissions = await odooClient.getUserPermissions();

//           // Map Odoo user to frontend User model
//           const user: User = {
//             id: odooUser.id.toString(),
//             email: odooUser.email,
//             firstName: odooUser.name.split(' ')[0] || 'User',
//             lastName: odooUser.name.split(' ').slice(1).join(' ') || '',
//             role: odooUser.is_admin ? 'admin' : 'user',
//             gallery: 'myself',
//             permissions,
//           };

//           const token = `odoo_session_${odooUser.id}_${Date.now()}`;

//           set({
//             token,
//             user,
//             isAuthenticated: true,
//           });

//           // Load user default currency
//           try {
//             const profile = await odooClient.getCompleteUserProfile();
//             if (profile?.defaultCurrency) {
//               useCurrencyStore.getState().initializeFromUserDefault(profile.defaultCurrency);
//             }
//           } catch (err) {
//             console.warn('Failed to load user default currency:', err);
//           }
//         } catch (error: any) {
//           console.error("Login failed (inside store):", error);

//           if (error.code === "2FA_REQUIRED" || error.message === "2FA_REQUIRED") {
//             throw error;
//           }

//           if (error.message?.includes("Invalid") || error.message?.includes("wrong")) {
//             throw new Error("Invalid email or password");
//           } else {
//             throw new Error("Unexpected error occurred while logging in");
//           }
//         }
//       },

//       // 🚪 FAST LOGOUT
//       logout: () => {
//         odooClient.logout();
//         set({
//           token: null,
//           user: null,
//           isAuthenticated: false,
//         });
//       },

//       // 👤 UPDATE USER INFO
//       updateUser: (userData: Partial<User>) => {
//         const currentUser = get().user;
//         if (currentUser) {
//           set({
//             user: { ...currentUser, ...userData },
//           });
//         }
//       },

//       // ✅ manually mark user as authenticated (used after OTP success)
//       setAuthenticated: (value: boolean) => {
//         set({ isAuthenticated: value });
//       },

//       // ✅ Refresh Odoo session info to confirm authentication
//       refreshSession: async () => {
//         try {
//           const baseURL = process.env.NODE_ENV === 'production' 
//             ? 'https://2.operacrm.com'
//             : 'https://2.operacrm.com';
//           const res = await fetch(`${baseURL}/web/session/get_session_info`, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             credentials: "include",
//             body: JSON.stringify({
//               jsonrpc: "2.0",
//               method: "call",
//               params: {},
//               id: Date.now(),
//             }),
//           });

//           const data = await res.json();
//           console.log("🔄 Session refresh result:", data);

//           if (data.result?.uid) {
//             const odooUser = {
//               id: data.result.uid,
//               email: data.result.email || "",
//               name: data.result.name || "User",
//               is_admin: data.result.is_admin || false,
//             };

//             const user: User = {
//               id: odooUser.id.toString(),
//               email: odooUser.email,
//               firstName: odooUser.name.split(" ")[0],
//               lastName: odooUser.name.split(" ").slice(1).join(" "),
//               role: odooUser.is_admin ? "admin" : "user",
//               gallery: "myself",
//             };

//             set({
//               user,
//               isAuthenticated: true,
//             });
//           } else {
//             set({
//               isAuthenticated: false,
//               user: null,
//             });
//           }
//         } catch (err) {
//           console.error("❌ Failed to refresh session:", err);
//           set({ isAuthenticated: false });
//         }
//       },
//     }),
//     {
//       name: 'auth-storage',
//       storage: createJSONStorage(() => localStorage),
//       partialize: (state) => ({
//         token: state.token,
//         user: state.user,
//         isAuthenticated: state.isAuthenticated,
//       }),
//       onRehydrateStorage: () => (state) => {
//         console.log('Auth state rehydrated:', {
//           hasUser: !!state?.user,
//           isAuthenticated: !!state?.isAuthenticated,
//         });
//       },
//     }
//   )
// );


// --------------------------------second working--------------------

// store/authStore.ts
// import { create } from "zustand";
// import { persist, createJSONStorage } from "zustand/middleware";
// import odooClient from "../services/odooClient";
// import { useCurrencyStore } from "./currencyStore";

// export interface User {
//   id: string;
//   email: string;
//   firstName: string;
//   lastName: string;
//   role: "admin" | "user";
//   gallery: "myself" | "worldwide";
//   permissions?: string[];
// }

// interface AuthState {
//   token: string | null;
//   user: User | null;
//   isAuthenticated: boolean;
//   login: (login: string, password: string) => Promise<void>;
//   logout: () => void;
//   updateUser: (user: Partial<User>) => void;
//   setAuthenticated: (value: boolean) => void;
//   refreshSession: () => Promise<void>;
// }

// export const useAuthStore = create<AuthState>()(
//   persist(
//     (set: any, get) => ({
//       token: null,
//       user: null,
//       isAuthenticated: false,

//       // Login with Odoo (handles 2FA)
//       login: async (loginStr: string, password: string) => {
//         try {
//           // odooClient.authenticate must return:
//           // { user: OdooUser|null, sessionId: string, twoFARequired: boolean }
//           const auth: any = await odooClient.authenticate(loginStr, password);
//           console.log("AUTH_RESPONSE:", auth);

//           // If 2FA is required, store pending info and throw so UI navigates to 2FA
//           if (auth.twoFARequired) {
//             localStorage.setItem("pending_2fa_login", loginStr);
//             localStorage.setItem("pending_2fa_pass", password);
//             if (auth.sessionId) localStorage.setItem("pending_2fa_session", auth.sessionId);

//             set({
//               user: null,
//               token: null,
//               isAuthenticated: false,
//             });

//             const err: any = new Error("2FA_REQUIRED");
//             err.code = "2FA_REQUIRED";
//             throw err;
//           }

//           // Normal login success
//           const odooUser = auth.user;
//           const permissions = await (async () => {
//             try {
//               return (odooClient as any).getUserPermissions ? await (odooClient as any).getUserPermissions() : [];
//             } catch (e) {
//               return [];
//             }
//           })();

//           const user: User = {
//             id: String(odooUser.id),
//             email: odooUser.email || "",
//             firstName: (odooUser.name || "").split(" ")[0] || "User",
//             lastName: (odooUser.name || "").split(" ").slice(1).join(" ") || "",
//             role: odooUser.is_admin ? "admin" : "user",
//             gallery: "myself",
//             permissions,
//           };

//           const token = `odoo_session_${odooUser.id}_${Date.now()}`;

//           // Cleanup any pending 2FA keys
//           localStorage.removeItem("pending_2fa_login");
//           localStorage.removeItem("pending_2fa_pass");
//           localStorage.removeItem("pending_2fa_session");

//           set({
//             token,
//             user,
//             isAuthenticated: true,
//           });

//           // Load user default currency if the client provides it
//           try {
//             const profile = await (odooClient as any).getCompleteUserProfile?.();
//             if (profile?.defaultCurrency) {
//               useCurrencyStore.getState().initializeFromUserDefault(profile.defaultCurrency);
//             }
//           } catch (err) {
//             console.warn("Failed to load user default currency:", err);
//           }
//         } catch (error: any) {
//           console.error("Login failed (inside store):", error);

//           if (error.code === "2FA_REQUIRED" || error.message === "2FA_REQUIRED") {
//             throw error;
//           }

//           if (error.message?.includes("Invalid") || error.message?.includes("wrong")) {
//             throw new Error("Invalid email or password");
//           }

//           throw new Error("Unexpected error occurred while logging in");
//         }
//       },

//       // Logout
//       logout: () => {
//         odooClient.logout();
//         set({
//           token: null,
//           user: null,
//           isAuthenticated: false,
//         });
//       },

//       // Update user
//       updateUser: (userData: Partial<User>) => {
//         const currentUser = get().user;
//         if (currentUser) {
//           set({
//             user: { ...currentUser, ...userData },
//           });
//         }
//       },

//       setAuthenticated: (value: boolean) => {
//         set({ isAuthenticated: value });
//       },

//       // Refresh session info (calls client's getSessionInfo)
//       refreshSession: async () => {
//         try {
//           const data = await odooClient.getSessionInfo();
//           // data may be shaped as { result: {...} } or { data: { result: {...} } } depending on wrapper
//           const result = data?.result || data?.result || null;

//           if (result?.uid) {
//             const odooUser = {
//               id: result.uid,
//               email: result.username || result.email || "",
//               name: result.name || "User",
//               is_admin: result.is_admin || false,
//             };

//             const user: User = {
//               id: String(odooUser.id),
//               email: odooUser.email,
//               firstName: (odooUser.name || "").split(" ")[0],
//               lastName: (odooUser.name || "").split(" ").slice(1).join(" "),
//               role: odooUser.is_admin ? "admin" : "user",
//               gallery: "myself",
//             };

//             set({
//               user,
//               isAuthenticated: true,
//             });
//           } else {
//             set({
//               isAuthenticated: false,
//               user: null,
//             });
//           }
//         } catch (err) {
//           console.error("❌ Failed to refresh session:", err);
//           set({ isAuthenticated: false, user: null });
//         }
//       },
//     }),
//     {
//       name: "auth-storage",
//       storage: createJSONStorage(() => localStorage),
//       partialize: (state) => ({
//         token: state.token,
//         user: state.user,
//         isAuthenticated: state.isAuthenticated,
//       }),
//       onRehydrateStorage: () => (state) => {
//         console.log("Auth state rehydrated:", {
//           hasUser: !!state?.user,
//           isAuthenticated: !!state?.isAuthenticated,
//         });
//       },
//     }
//   )
// );

// export default useAuthStore;



// store/authStore.ts
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import odooClient from "../services/odooClient";
import { useCurrencyStore } from "./currencyStore";

/**
 * Auth store for OperaCRM frontend
 * - Handles login / 2FA flow
 * - Does NOT call get_session_info too early (prevents session replacement)
 * - Fetches permissions only after session is stable
 * - Adds debug logs to help trace issues
 */

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: "admin" | "user";
  gallery: "myself" | "worldwide";
  permissions?: string[];
}

interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  permissionsLoaded: boolean;
  login: (login: string, password: string) => Promise<void>;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
  setAuthenticated: (value: boolean) => void;
  refreshSession: (opts?: { poll?: boolean }) => Promise<void>;
  fetchPermissionsIfNeeded: () => Promise<string[]>;
}

let permissionsRequest: Promise<string[]> | null = null;

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      permissionsLoaded: false,

      // LOGIN: calls backend authenticate (handles 2FA detection)
      login: async (loginStr: string, password: string) => {
        console.log("[auth] login start", loginStr);
        try {
          const auth: any = await odooClient.authenticate(loginStr, password);
          console.log("[auth] authenticate response:", auth);

          // If 2FA required, store pending and throw — UI should navigate to 2FA screen
          // if (auth.twoFARequired) {
          //   console.log("[auth] 2FA required for", loginStr);
          //   localStorage.setItem("pending_2fa_login", loginStr);
          //   localStorage.setItem("pending_2fa_pass", password);
          //   if (auth.sessionId) localStorage.setItem("pending_2fa_session", auth.sessionId);

          //    set({
          //       isAuthenticated: false,  // but keep user data intact
          //     });

          //   const err: any = new Error("2FA_REQUIRED");
          //   err.code = "2FA_REQUIRED";
          //   throw err;
          // }
          if (auth.twoFARequired) {
            console.log("🔥 2FA triggered by Odoo");

            set({ isAuthenticated: false });

            const err: any = new Error("2FA_REQUIRED");
            err.code = "2FA_REQUIRED";
            throw err;
          }

          if (!auth.user) {
            console.warn("⛔ auth.user is NULL → 2FA flow active. Normal login STOPPED.");
            return; // <- THIS FIXES YOUR DASHBOARD EMPTY
          }

          // Normal login (no 2FA)
          const odooUser = auth.user;

          console.log("[auth] login success uid=", odooUser);


          // Wait a tiny bit to let browser commit cookie (rare races)
          await new Promise((r) => setTimeout(r, 120));

          // Now try to refresh session info (poll briefly until server returns uid)
          await get().refreshSession({ poll: true });

          // After session stable, fetch permissions (safe)
          const permissions = await get().fetchPermissionsIfNeeded();

          const user: User = {
            id: String(odooUser.id),
            email: odooUser.email || "",
            firstName: (odooUser.name || "").split(" ")[0] || "User",
            lastName: (odooUser.name || "").split(" ").slice(1).join(" ") || "",
            role: odooUser.is_admin ? "admin" : "user",
            gallery: "myself",
            permissions,
          };

          const token = `odoo_session_${odooUser.id}_${Date.now()}`;

          // Cleanup any pending 2FA
          localStorage.removeItem("pending_2fa_login");
          localStorage.removeItem("pending_2fa_pass");
          localStorage.removeItem("pending_2fa_session");


          set({
            token,
            user,
            isAuthenticated: true,
            permissionsLoaded: true,
          });

          const backendUrl =
            (odooClient as any)["backendURL"] ||
            process.env.REACT_APP_BACKEND_URL ||
            "";
          // fetch(`${backendUrl}/api/activity`, {
          //   method: "POST",
          //   headers: { "Content-Type": "application/json" },
          //   credentials: "include",
          //   body: JSON.stringify({
          //     user_id: String(odooUser.id),
          //     user_name: `${odooUser.name || ""}`,
          //     action: "login",
          //     meta: {
          //       role: odooUser.is_admin ? "admin" : "user",
          //       email: odooUser.login || "",
          //     },
          //   }),
          // });
          fetch(`${backendUrl}/api/activity`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({
              user_id: String(odooUser.id),
              user_name: `${odooUser.name || ""}`,
              action: "login",
              meta: {
                role: odooUser.is_admin ? "admin" : "user",
                email: odooUser.login || "",
              },
            }),
          });



          // Load default currency if available (best effort)
          try {
            const profile = await (odooClient as any).getCompleteUserProfile?.();
            if (profile?.defaultCurrency) {
              useCurrencyStore.getState().initializeFromUserDefault(profile.defaultCurrency);
            }
          } catch (err) {
            console.warn("[auth] load profile failed", err);
          }
        } catch (error: any) {
          console.error("[auth] login failed", error);
          if (error.code === "2FA_REQUIRED" || error.message === "2FA_REQUIRED") {
            throw error;
          }
          if (error.message?.includes("Invalid") || error.message?.includes("wrong")) {
            throw new Error("Invalid email or password");
          }
          throw new Error(error?.message || "Unexpected error occurred while logging in");
        }
      },

      // LOGOUT
      logout: () => {
        console.log("[auth] logout called");
        try {

          odooClient.logout();
        } catch (e) {
          console.warn("[auth] logout call failed", e);
        }
        set({
          token: null,
          user: null,
          isAuthenticated: false,
          permissionsLoaded: false,
        });
        // cleanup local storage keys we use
        localStorage.removeItem("pending_2fa_login");
        localStorage.removeItem("pending_2fa_pass");
        localStorage.removeItem("pending_2fa_session");
        localStorage.removeItem("odoo_user");
        localStorage.removeItem("odoo_session");
      },

      // Update user partial
      updateUser: (userData: Partial<User>) => {
        const currentUser = get().user;
        if (currentUser) {
          set({
            user: { ...currentUser, ...userData },
            permissionsLoaded: Object.prototype.hasOwnProperty.call(
              userData,
              "permissions",
            )
              ? true
              : get().permissionsLoaded,
          });
        }
      },

      setAuthenticated: (value: boolean) => {
        set({ isAuthenticated: value });
      },

      /**
       * refreshSession
       * - Calls odooClient.getSessionInfo()
       * - If opts.poll=true it will poll a few times (short) until uid appears (useful just after OTP)
       * - This avoids calling get_session_info exactly at the same time server is still processing and creating a fresh session
       */
      refreshSession: async ({ poll = false } = {}) => {

        const attempts = poll ? 12 : 1;
        const delay = poll ? 300 : 0;

        for (let i = 0; i < attempts; i++) {

          const res = await odooClient.getSessionInfo();

          // handle expired cookie ONLY WHEN polling
          if (res?.error?.code === 100) {
            console.warn("SessionExpired — retrying...", i);
          }

          else if (
            res?.result?.uid !== null &&
            res?.result?.uid !== false &&
            typeof res?.result?.uid !== "undefined") {
            console.log("Session stabilized with UID:", res.result.uid);
            // build user, set store, return
            const u = res.result;
            set({
              isAuthenticated: true,
              permissionsLoaded: false,
              user: {
                id: String(u.uid),
                email: u.username || u.email,
                firstName: u.name.split(" ")[0],
                lastName: u.name.split(" ").slice(1).join(" "),
                role: u.is_admin ? "admin" : "user",
                gallery: "myself",
              }
            });

            await odooClient.syncUserCompanyFromSession();

            return;
          }

          await new Promise(r => setTimeout(r, delay));
        }

        set({ isAuthenticated: false, user: null });
      },


      /**
       * fetchPermissionsIfNeeded
       * - Safe: only calls controller /api/permissions after session is stable
       * - caches result in user.permissions (in-memory)
       */
      fetchPermissionsIfNeeded: async () => {
        try {
          const { user, permissionsLoaded, isAuthenticated } = get();
          if (!isAuthenticated || !user) return [];

          const existing = user.permissions;
          if (permissionsLoaded) {
            return Array.isArray(existing) ? existing : [];
          }

          if (permissionsRequest) {
            return await permissionsRequest;
          }

          permissionsRequest = (async () => {
            try {
              const perms = await (odooClient as any).getUserPermissions?.();
              const normalized = Array.isArray(perms) ? perms : [];
              const usr = get().user;
              if (usr) {
                set({
                  user: { ...usr, permissions: normalized },
                  permissionsLoaded: true,
                });
              } else {
                set({ permissionsLoaded: true });
              }
              return normalized;
            } catch (permErr) {
              console.warn("[auth] permissions call failed", permErr);
              set({ permissionsLoaded: true });
              return [];
            } finally {
              permissionsRequest = null;
            }
          })();

          return await permissionsRequest;
        } catch (e) {
          console.error("[auth] fetchPermissionsIfNeeded error", e);
          return [];
        }
      },
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),

      partialize: (state) => ({
        token: state.token,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
        permissionsLoaded: state.permissionsLoaded,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.permissionsLoaded =
            state.permissionsLoaded ||
            Array.isArray(state.user?.permissions);
        }
        console.log("[auth] rehydrated:", { hasUser: !!state?.user, isAuthenticated: !!state?.isAuthenticated });
      },
    }
  )
);

export default useAuthStore;
